import { catchError, filter, map, switchMap } from 'rxjs/operators';
import { concat, EMPTY, of } from 'rxjs';
import axios from 'axios-observable';
import { PayloadEpic } from '@/store/epics/epic-types';
import { actions, asyncActions } from '@/store/slices';
import { apiEndpoints } from '@/store/constants';
import { objectToUrlSearchParams } from '@/utils/url-search-params-utils';
import { AuditLogModel } from '@/models';
import { FetchAllAuditLogsPayload } from '@/store/slices/payload-types/audit-log-payload-types';

export const fetchAllPublicAuditLogsEpic: PayloadEpic<FetchAllAuditLogsPayload, AuditLogModel[]> = (action$) => {
    return action$.pipe(
        filter(asyncActions.publicAuditLogs.fetchAll.match),
        switchMap(({ payload }) => concat(
            of(actions.publicAuditLogs.setIsLoading(true)),
            fetchAllAuditLogs(payload).pipe(
                map(({ data }) => actions.publicAuditLogs.upsertMany({
                    auditLogs: data.results,
                    filter: payload,
                    totalCount: data.count,
                })),
                catchError((error) => {
                    console.error('fetchAllPublicAuditLogsEpic', error);

                    return EMPTY;
                }),
            ),
            of(actions.publicAuditLogs.setIsLoading(false)),
        )),
    );
};

const fetchAllAuditLogs = (filters) => {
    const params = objectToUrlSearchParams(filters);

    return axios.get<ListResponse<AuditLogModel>>(`${apiEndpoints.publicAuditLogs()}`, { params });
};
